'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const ModalView = require('common/ui/view/modal/index');
const ReleaseNoteEntity = require('feedback/domain/entity/release-note');
const AnnouncementModalView = require('feedback/ui/view/modal/announcement');
const IdeaRelatedListView = require('feedback/ui/view/idea/related-list');
const AdminCoverView = require('feedback/ui/view/admin/common/cover');
const Template = require('feedback/ui/template/admin/announcement/detail.hbs');
const AnnouncementUpdateService = require('feedback/app/service/announcement/update');
const Marked = require('balus/util/marked');

const DetailView = Mn.View.extend({
    tagName: 'div',
    className: 'announcement-detail',
    template: Template,
    regions: {
        announcementDetail: '.announcement-detail',
        ideaRelatedList: '.idea-related-list',
        cover: '#cover',
    },
    ui: {
        announcementEditButton: '.announcement-edit-button'
    },
    events: {
        'click @ui.announcementEditButton': 'editAnnouncement'
    },
    modelEvents: {
        'change': 'render'
    },

    templateContext: function() {
        return {
            title: this.model.getTitle(),
            category: this.model.getCategoryName(),
            description: Marked()(this.model.getDescription()),
            publishedAt: this.model.getPublishedAt(),
            state: i18n.t(`feedback:announcement.state.${this.model.getState()}`),
            categoryName: i18n.t(`feedback:announcement.category.${this.model.getCategoryName()}`),
            isReleaseNote: this.isReleaseNote()
        }
    },

    onRender: function() {
        this.showChildView('cover', new AdminCoverView({isAnnouncement: true}));

        if(this.isReleaseNote()) {
            this.showChildView('ideaRelatedList', new IdeaRelatedListView({
                ideaKeys: this.model.getIdeaKeys()
            }));
        }
    },

    editAnnouncement: function() {
        const announcementID = this.model.getID();
        const modal = new ModalView({
            title: i18n.t('feedback_template:announcement.manage.modal.edit.title'),
            bodyView: new AnnouncementModalView({
                model: this.model,
                isEditing: true
            }),
            large: true,
            onChildviewSave: function() {
                const announcementJSON = this.getChildView('body').getAttributes();
                this.disableButtons();

                const service = new AnnouncementUpdateService(announcementID, announcementJSON);
                service.update()
                    .then((updatedModel) => {
                        this.trigger('updated', updatedModel);
                        this.hide();
                    });
            }
        });
        modal.show();
        this.listenTo(modal, 'updated', function(updatedModel) {
            // category を変更する更新をすると Model が変更されるので、
            // this.model に設定し render しなおす
            this.model = updatedModel;
            this.render();
        })
    },

    isReleaseNote: function() {
        return this.model instanceof ReleaseNoteEntity;
    }
});

module.exports = DetailView;



// WEBPACK FOOTER //
// ./feedback/ui/view/admin/announcement/detail.js